import dayjs from 'dayjs'
import advanced from 'dayjs/plugin/advancedFormat'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(advanced)

type DateWithTimezone = {
  date: Date
  profileTimezone?: string
}

type DateStringOptions = {
  createdAt?: number
  twentyFourHourTime?: boolean
}

const getOrdinalSuffix = (dayNumber: number): string => {
  const absoluteDay = Math.abs(dayNumber)
  const lastTwoDigits = absoluteDay % 100
  if (lastTwoDigits >= 11 && lastTwoDigits <= 13) return 'th'

  switch (absoluteDay % 10) {
    case 1:
      return 'st'
    case 2:
      return 'nd'
    case 3:
      return 'rd'
    default:
      return 'th'
  }
}
const isToday = ({ date, profileTimezone }: DateWithTimezone): boolean => {
  const today = new Date()
  const todayAsMoment = dayjs.tz(today, profileTimezone)
  const inputDateAsMoment = dayjs.tz(date, profileTimezone)
  return (
    todayAsMoment.format('YYYY-MM-DD') ===
    inputDateAsMoment.format('YYYY-MM-DD')
  )
}
const daysSinceDate = ({ date, profileTimezone }: DateWithTimezone): number => {
  const today = new Date()
  const todayAsMoment = dayjs.tz(today, profileTimezone)
  const inputDateAsMoment = dayjs.tz(date, profileTimezone)
  const days = todayAsMoment.diff(inputDateAsMoment, 'days')
  return days
}
export const getDateString = (
  unconvertedDate: number,
  profileTimezone?: string,
  options?: DateStringOptions,
): string => {
  options = options || {}
  const date = new Date(unconvertedDate * 1000)
  const scheduledAtMoment = dayjs.tz(date, profileTimezone)
  const monthName = scheduledAtMoment.format('MMMM')
  const day = scheduledAtMoment.date()
  const ordinalSuffix = getOrdinalSuffix(day)
  let time
  if (options.twentyFourHourTime) {
    time = scheduledAtMoment.format('HH:mm')
  } else {
    time = scheduledAtMoment.format('h:mm A')
  }
  const zone = scheduledAtMoment.format('z')
  const timeString = `at ${time} (${zone})`
  if (isToday({ date, profileTimezone })) {
    return `today ${timeString}`
  }
  if (options.createdAt && daysSinceDate({ date, profileTimezone }) >= 3) {
    return `on ${monthName} ${day}${ordinalSuffix}`
  }
  return `${monthName} ${day}${ordinalSuffix} ${timeString}`
}
export const isInThePast = (unconvertedDate?: number | null): boolean => {
  if (!unconvertedDate) return false
  const date = new Date(unconvertedDate * 1000)
  const now = new Date()
  return date < now
}
export const daysAgoTimestamp = (days: number): number => {
  const date = new Date()
  date.setDate(date.getDate() - days)
  return Math.ceil(date.getTime() / 1000)
}
export default {
  getDateString,
  isInThePast,
  daysAgoTimestamp,
}
